import React,{ createContext, useContext, useState } from "react";
import { dark, light, sizes } from "./theme";
import { ThemeProvider } from "styled-components";
// type Props = {
//   children: React.ReactNode;
// };

// type ContextProps = {
//   themeToggle?: VoidFunction;
//   mode: "dark" | "light";
// };

export const StyledThemeContext = createContext(null);

export const StyledThemeProvider = ({ children }) => {
  const [mode, setMode] = useState("light");

  const themes = {
    light,
    dark,
  };

  const themeToggle = () => {
    setMode((prev) => (prev === "dark" ? "light" : "dark"));
  };

  const theme = themes[mode];

  return (
    <StyledThemeContext.Provider value={{ themeToggle, mode }}>
      <ThemeProvider theme={{ ...theme, sizes }}>{children}</ThemeProvider>
    </StyledThemeContext.Provider>
  );
};

export const useStyledTheme = () => useContext(StyledThemeContext);
